import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=0b15d5af&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b15d5af')) {
      api.createRecord('0b15d5af', component.options)
    } else {
      api.reload('0b15d5af', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=0b15d5af&", function () {
      api.rerender('0b15d5af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203o1cdn0pv03/JS/comp/ImgFallback2.vue"
export default component.exports